<!-- Revised on 2025/10/16 by mnavarro -->
<template>
  <div class="dropdown d-inline">
    <Button id="importStatusFilter" color="primary" :title="$t('key_filter_status')" class="dropdown-toggle ms-2 " :variant="statusSelected == '' ? 'outline' : 'fill'"
      data-bs-toggle="dropdown" aria-expanded="false">
      <i class="fa-solid fa-tags me-1" aria-hidden="true"></i>
    </Button>
    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="importStatusFilter">
      <li>
        <button class="dropdown-item border-radius-md text-success" :class="[filterStatusSelected=='FINALIZADO'?'active-item':'']" type="button" @click="handleClick('FINALIZADO')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-check me-3 text-success"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_success') }}</span>
        </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-error" :class="[filterStatusSelected=='ERROR'?'active-item':'']" type="button" @click="handleClick('ERROR')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-xmark me-3 text-error"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_error') }}</span>
        </button>
      </li>
      <li>
        <hr class="horizontal dark my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-clearfilter" type="button" @click="handleClick('')">
          <span class="btn-inner--icon">
            <i class="fa-solid fa-eraser me-3 text-clearfilter"></i>
          </span>
          <span class="btn-inner--text">{{ $t('key_filter_clear_filters') }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

  import Button from "./../../../../generic_components/Button.vue";

  export default {
    name:"ImportStatusFilter",
    components: {
      Button
    },
    props: {
      filterStatusSelected: {
        type: String,
        default: () => ''
      }
    },
    emits: ['import-status-filter-change'],
    data() {
      return {
        statusSelected: ''
      }
    },
    watch: {
      filterStatusSelected() {
        this.statusSelected = this.filterStatusSelected;
      }
    },
    methods: {
      handleClick(status) {
        this.statusSelected = status;
        this.$emit('import-status-filter-change', status);

        const dropdownElement = document.querySelector('.dropdown-menu.show');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }
  }

</script>
